/**
 * An optional string field for an extension's `configSchema`. The framework
 * accepts any Standard Schema that also converts to JSON Schema; the app has
 * no schema library of its own (zod is not an app dependency, SR-10), so
 * this is the same small object the framework uses internally for `title`
 * and `path`.
 */
export const optionalStringConfig = {
  '~standard': {
    version: 1 as const,
    vendor: 'byx',
    validate(value: unknown) {
      if (value === undefined || typeof value === 'string') {
        return { value: value as string | undefined };
      }
      return {
        issues: [
          { message: `Expected a string, but received ${typeof value}` },
        ],
      };
    },
    jsonSchema: {
      input: () => ({ type: 'string' }),
      output: () => ({ type: 'string' }),
    },
    types: undefined as unknown as {
      input: string | undefined;
      output: string | undefined;
    },
  },
};
